import { registerSW } from "virtual:pwa-register";

// A tab (or installed PWA window) can stay open for weeks without a full
// navigation, so the browser's own "check sw.js on page load" update
// mechanism never fires. We poll for a new service worker on an interval,
// and — since registerType is "autoUpdate" — reload as soon as one takes
// over, so the running tab actually picks up the new JS/HTML instead of
// silently serving whatever was loaded when the tab was first opened.
const CHECK_INTERVAL_MS = 60 * 60 * 1000;

export function registerAppServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      updateSW(true);
    },
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      setInterval(() => {
        registration.update().catch(() => {});
      }, CHECK_INTERVAL_MS);
    },
  });

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  });
}
